import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 데이터를 가져온 후 1분 동안은 fresh 상태로 간주하여 재요청하지 않음
      staleTime: 60 * 1000,
      // 브라우저 탭에 다시 포커스가 와도 자동으로 데이터를 재조회하지 않음
      refetchOnWindowFocus: false,
    },
  },
});
